//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { isEmailOrIsPhone } from '~/utils/tools';
import { addSubs } from '@/api/subs';
import MgButton from '@/components/custom/mg-button.vue';
import MgInput from '@/components/custom/mg-input.vue';

export default {
  components: {
    MgButton,
    MgInput,
  },
  data() {
    return {
      warningText: '请输入正确的手机号/邮箱',
      isWarning: false,
      disabled: true,
      inputVal: '',
      borderName: '',
      types: {
        phoneNumber: {
          type: 'phoneNumber',
          isBind: false,
          isChecked: false,
          text: '',
        },
        email: {
          type: 'email',
          isBind: false,
          isChecked: false,
          text: '',
        },
      },
    };
  },
  props: {
    type: {
      type: String,
      default: '',
    },
  },
  computed: {
    userInfo() {
      return this.$store.state.user.userInfo;
    },
    isBind() {
      return this.userInfo.eamil && this.userInfo.phoneNumber;
    },
    isShowSubScribe() {
      return this.$store.state.user.isShowSubScribe;
    },
  },
  watch: {
    inputVal(nval) {
      if (this.isWarning) {
        this.isWarning = false;
        this.warningText = '请输入正确的手机号/邮箱';
      }
      this.disabled = nval === '';
    },
    isShowSubScribe() {
      this.initType();
      this.initDisabled();
    },
  },
  mounted() {
    this.initType();
    this.initDisabled();
  },
  methods: {
    initType() {
      if (this.userInfo.phoneNumber) {
        this.types.phoneNumber.text = `手机号： ${this.userInfo.phoneNumber}`;
        this.types.phoneNumber.isBind = true;
      } else {
        this.types.phoneNumber.text = `未绑定手机号`;
        this.types.phoneNumber.isBind = false;
      }

      if (this.userInfo.email) {
        this.types.email.text = `邮箱： ${this.userInfo.email}`;
        this.types.email.isBind = true;
      } else {
        this.types.email.text = `未绑定邮箱`;
        this.types.email.isBind = false;
      }

      if (this.userInfo.email) {
        this.types.email.isChecked = true;
        return;
      }

      if (this.userInfo.phoneNumber) {
        this.types.phoneNumber.isChecked = true;
      }
    },
    async reload() {
      await this.$plugin
        .login()
        .then((res) => {
          this.$store.commit('user/setUserInfo', res.data);
        })
        .catch(() => {
          this.$store.commit('user/setUserInfo', { login_http_mark: true });
        });
      this.initType();
      this.initDisabled();
    },
    checked(type) {
      this.types[type].isChecked = !this.types[type].isChecked;
      this.disabled = !(this.types.phoneNumber.isChecked || this.types.email.isChecked);
    },
    bind() {
      window.open('/files/account');
    },
    showWarn() {
      this.borderName = 'input-waring';
      this.isWarning = true;
    },
    async subscription() {
      if (!this.userInfo.id && !isEmailOrIsPhone(this.inputVal)) {
        this.showWarn();
        return;
      }

      let email = '';
      let phone = '';
      const curType = this.type;
      if (this.userInfo.id) {
        email = this.types.email.isChecked ? this.userInfo.email : '';
        phone = this.types.phoneNumber.isChecked ? this.userInfo.phoneNumber : '';
      } else {
        email = this.inputVal.indexOf('@') !== -1 ? this.inputVal : '';
        phone = this.inputVal.indexOf('@') === -1 ? this.inputVal : '';
      }
      try {
        await addSubs({
          email,
          phone,
          sub_module: curType,
        });
        this.$emit('handleSubs');
      } catch (e) {
        if (e?.response?.data?.code === 'InternalError') {
          this.warningText = '订阅失败，请稍后重试';
        }
        this.showWarn();
      }
    },
    close() {
      this.$emit('close');
    },
    handleFous() {
      this.isWarning = false;
      this.borderName = 'input-border';
    },
    changeInput(nval) {
      this.isWarning = false;
      this.disabled = nval === '';
      this.inputVal = nval;
    },
    handleBlur() {
      this.borderName = '';
      if (this.inputVal !== '' && !isEmailOrIsPhone(this.inputVal)) {
        this.showWarn();
      }
    },
    initDisabled() {
      if (this.userInfo.id) {
        this.disabled = !(this.types.phoneNumber.isChecked || this.types.email.isChecked);
      }
    },
  },
};
